// extracted by mini-css-extract-plugin
module.exports = {"pre":"codeBlock_pre__9zxRp","code":"codeBlock_code___BeCQ"};